export const useEditorVisibilityLockHandlers = ({
  layerCompData,
  editComponent,
  setSelectedComponent,
  setScrollbarItems,
  setLayerCompData,
  setOpenTimelinePopup,
}) => {
  const toggleLockComp = (itemSelected) => {
    if (typeof setOpenTimelinePopup === "function") {
      setOpenTimelinePopup({
        popupWindow: false,
        fromUnRedo: false,
      });
    }

    let tempScrollbarComponents = layerCompData?.find(
      (component) => component.id === editComponent?.id,
    )?.scrollbarComponents;

    let newLayer = [
      ...(editComponent ? tempScrollbarComponents : layerCompData),
    ];
    let tempSelected = {
      ...itemSelected,
      componentStyles: {
        ...itemSelected.componentStyles,
        lockBoolean:
          itemSelected.componentStyles.lockBoolean === false ? true : false,
      },
    };
    setSelectedComponent(tempSelected);
    if (editComponent) {
      newLayer[
        tempScrollbarComponents.findIndex(
          (selComp) => selComp.id === itemSelected.id,
        )
      ] = tempSelected;
      setScrollbarItems(newLayer);
    } else {
      newLayer[
        layerCompData.findIndex((selComp) => selComp.id === itemSelected.id)
      ] = tempSelected;
      setLayerCompData(newLayer);
    }
  };

  const toggleHideComp = (itemSelected) => {
    if (typeof setOpenTimelinePopup === "function") {
      setOpenTimelinePopup({
        popupWindow: false,
        fromUnRedo: false,
      });
    }

    let tempScrollbarComponents = layerCompData.find(
      (component) => component.id === editComponent?.id,
    )?.scrollbarComponents;
    let newLayer = [
      ...(editComponent ? tempScrollbarComponents : layerCompData),
    ];
    let tempSelected = {
      ...itemSelected,
      componentStyles: {
        ...itemSelected.componentStyles,
        hideBoolean:
          itemSelected.componentStyles.hideBoolean === false ? true : false,
      },
    };
    setSelectedComponent(tempSelected);
    tempSelected.componentStyles.opacity = tempSelected.componentStyles.hideBoolean
      ? 0
      : 1;

    if (editComponent) {
      newLayer[
        tempScrollbarComponents.findIndex(
          (selComp) => selComp.id === itemSelected.id,
        )
      ] = tempSelected;
      setScrollbarItems(newLayer);
    } else {
      newLayer[
        layerCompData.findIndex((selComp) => selComp.id === itemSelected.id)
      ] = tempSelected;
      setLayerCompData(newLayer);
    }
  };

  return { toggleLockComp, toggleHideComp };
};
